import styled from 'styled-components'
import { Card } from '../Layout/CommonStyle'
import { Link } from 'react-router-dom'
import { IconButton, Tooltip } from '@mui/material'
import {
  Star,
  StarOutlineOutlined,
  WorkOutlineOutlined,
} from '@mui/icons-material'

type JobProps = {
  id: number
  name: string
  image: string
  description: string
  isInInventory?: boolean
  onChangeToInventory?: (jobId: number, isAdd: boolean) => void
}

function Job(props: JobProps) {
  const onChangeToInventory = (e: React.MouseEvent<SVGSVGElement>) => {
    e.preventDefault()
    if (props.onChangeToInventory !== undefined) {
      props.onChangeToInventory(props.id, !props.isInInventory)
    }
  }

  return (
    <Container>
      <Link to={'/job/' + props.id}>
        <img src={props.image} className="image" />
        <div>
          {props.name}

          {props.isInInventory ? (
            <div className="rightTop">
              <Star style={{ color: '#64B5F6' }} />
            </div>
          ) : (
            <Tooltip title="인벤토리에 추가" className="rightTop">
              <WorkOutlineOutlined
                fontSize="small"
                onClick={(e) => onChangeToInventory(e)}
              />
            </Tooltip>
          )}
        </div>
        <div>{props.description}</div>
      </Link>
    </Container>
  )
}

const IconButtonStyle = styled(IconButton)`
  width: 20px;
  height: 20px;
`
const Container = styled(Card)`
  border: 1px solid #eee;
  padding: 6px;
  margin-bottom: 5px;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: aliceblue;
  }

  a {
    display: grid;
    grid-template-columns: 120px 1fr;
    grid-template-rows: 20px 90px;
    grid-gap: 10px;

    img {
      grid-row: 1/3;
      width: 120px;
    }

    div {
      color: #666;
      line-height: 1.3;
    }
    & > div:nth-child(2) {
      font-size: 1.05rem;
      font-weight: 600;
      color: #333;

      position: relative;
      img {
        position: absolute;
        right: 0;
        top: 0;
        width: 24px;
        height: 24px;
      }

      .rightTop {
        cursor: pointer;
        border: none;
        position: absolute;
        right: 0;
        top: 0;
        color: #666;
      }
    }

    position: relative;
  }
`

const RightTop = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`

export default Job
